import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(
  ({ spacing, colors, border }, { insets }) => ({
    container: {
      flex: 1,
      paddingVertical: {
        xs: spacing(20) + insets.top,
        sm: spacing(42) + insets.top,
      },
      paddingHorizontal: {
        xs: spacing(4),
        sm: spacing(6),
      },
    },
    form: {
      gap: spacing(2),
      borderRadius: border.radius.md,
      width: "100%",
      maxWidth: spacing(144),
      marginHorizontal: "auto",
      padding: {
        sm: spacing(8),
      },
      backgroundColor: {
        sm: colors.backgroundFloat,
      },
    },
    header: {
      gap: spacing(4),
      marginBottom: spacing(12),
    },
    logo: {
      height: spacing(8),
      aspectRatio: 4 / 3,
      marginVertical: spacing(4),
    },
    field: {
      width: "100%",
      gap: spacing(2),
      marginBottom: spacing(6),
    },
    button: {
      marginTop: spacing(4),
    },
  }),
);

export default stylesheet;
